module.exports = {
      id: "logout-mobile-usage",
      viewBox: "0 0 20.886 28.808",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#logout-mobile",
      toString: function () {
        return this.url;
      }
    }